import { api } from "@/libs/api-client";
import { usernameSchema } from "@/libs/auth/schema";
import type { GenericApiResponse } from "@/types/api-types";
import { createServerFn } from "@tanstack/react-start";
import { zodValidator } from "@tanstack/zod-adapter";
import { z } from "zod";

export const updateProfileSchema = z.object({
  username: usernameSchema,
  nickname: z.string().min(1, "昵称不能为空"),
  bio: z.string().max(160, "个人简介不能超过160个字符"),
});

export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;

function updateNickname(nickname: string) {
  return api
    .post("user/updateNickName", {
      json: { nickName: nickname },
    })
    .json<GenericApiResponse>();
}

function updateBio(bio: string) {
  return api
    .post("user/updateIntroduction", {
      json: { introduction: bio },
    })
    .json<GenericApiResponse>();
}

export const updateProfile = createServerFn({ method: "POST" })
  .validator(zodValidator(updateProfileSchema))
  .handler(async ({ data }) => {
    const [nicknameResponse, bioResponse] = await Promise.all([
      updateNickname(data.nickname),
      updateBio(data.bio),
    ]);

    return nicknameResponse.ok && bioResponse.ok;
  });
